function clearCpfCnpj(cpf) {
    if (cpf) {
        cpf = cpf.replace(/\./g, '');
        cpf = cpf.replace(/\-/g, '');
        cpf = cpf.replace(/\//g, '');
    }

    return cpf;
};

function clearPhone(phone) {
    if (phone) {
        phone = phone.replace(/\(/g, '')
        phone = phone.replace(/\)/g, '')
        phone = phone.replace(/\-/g, '')
        phone = phone.replace(/\s+/g, '')
    }

    return phone
}

function formatPhone(phone) {
   return phone.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
}

function formatCnpj(cnpj) {
   return cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
}

function formatCpf(cpf) {
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
}

function formatCep(cep) {
   return cep.replace(/(\d{5})(\d{3})/, '$1-$2');
}

function isUndefinedOrNullOrEmptyOrZero(param) {
    return param == undefined || param == null || param == '' || param == '0';
}

module.exports = {
    clearCpfCnpj: clearCpfCnpj,
    clearPhone: clearPhone,
    formatPhone: formatPhone,
    formatCpf: formatCpf,
    formatCnpj: formatCnpj,
    formatCep: formatCep,
    isUndefinedOrNull: function (param) {
        return param == undefined || param == null;
    },
    isUndefinedOrNullOrEmpty: function (param) {
        return param == undefined || param == null || param == '';
    },
    isNotUndefinedOrNullOrEmptyOrZero(param) { return !isUndefinedOrNullOrEmptyOrZero(param); }
}



// WEBPACK FOOTER //
// ./src/services/string.js